import styled from 'styled-components';
import {theme} from '@styles/theme';

export const StatusLabelWrapper = styled.div<{type: 'red' | 'green' | 'yellow'}>`
  padding: 4px 12px;
  background-color: ${({type}) =>
    type == 'red'
      ? theme.colors.signalRed01
      : type == 'yellow'
        ? theme.colors.signalOrange01
        : theme.colors.signalGreen01};
  border-width: 1px;
  border-style: solid;
  border-color: ${({type}) =>
    type == 'red'
      ? theme.colors.signalRed00
      : type == 'yellow'
        ? theme.colors.signalOrange00
        : theme.colors.signalGreen00};
  border-radius: 16px;
`;
